import {matchPath} from "react-router-dom-v5-compat";

const ASSESSMENT_PATHS = [
    // Course & Mastery Challenge
    "/:domain/:course/test/*",
    // Unit Quiz/Test
    "/:domain/:course/:unit/quiz/:slug",
    "/:domain/:course/:unit/test/:slug",
    "/:domain/:course/:unit/:lesson/quiz/:slug",
    "/:domain/:course/:unit/:lesson/test/:slug",
];

const DISABLED_PATHS = [
    // Specific Teacher Activities
    "/profile/me/khanmigo/activities/activity-default-teacher",

    // Specific Parent Activities
    "/profile/me/khanmigo/activities/activity-default-parent",

    // Specific Learner Activities
    "/profile/me/khanmigo/activities/activity-default-learner",
].concat(ASSESSMENT_PATHS);

/**
 * Determines if the Guide chat interaction is diabled on given path.
 */
export const isGuideChatDisabled = (path: string): boolean =>
    DISABLED_PATHS.some((disabledPath) => matchPath(disabledPath, path));

export const isGuideChatDisabledForAssessment = (path: string): boolean =>
    ASSESSMENT_PATHS.some((assessmentPath) => matchPath(assessmentPath, path));
